import { render, staticRenderFns } from "./SummaryModal.vue?vue&type=template&id=6976aa2e&"
import script from "./SummaryModal.vue?vue&type=script&lang=js&"
export * from "./SummaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports